export default {
  title: {
    en: 'Check upgrade summary',
  },
}
